import React from 'react';
import { Card, CTAButton, Stepper } from '../../../../components';
import { DashboardLayout } from '../../../../layouts';
import './Layout.scss';

interface Props {
  children: JSX.Element | JSX.Element[];
  className: string;
  currentStep: number;
  ctaLabel?: string;
  disableCta?: boolean;
  overflow?: true;
  handleCtaClick?: () => void;
}

const Layout = ({
  children,
  className,
  currentStep,
  ctaLabel,
  disableCta,
  overflow,
  handleCtaClick,
}: Props): JSX.Element => (
  <DashboardLayout title="Send Forms & Documents">
    <Card className={`SendFormsAndDocuments-layout ${overflow ? 'mod-overflow' : ''}`}>
      <Stepper
        currentStep={currentStep}
        steps={['Select Patient', 'Select Document', 'Review & Submit', 'Completed']}
      />
      <div className={`SendFormsAndDocuments-layout-children ${className}`}>{children}</div>
      {ctaLabel && (
        <div className="SendFormsAndDocuments-layout-cta-button-container">
          <CTAButton
            disabled={disableCta}
            onClick={handleCtaClick}
            className="SendFormsAndDocuments-layout-cta-button"
            text={ctaLabel}
          />
        </div>
      )}
    </Card>
  </DashboardLayout>
);

export default Layout;
